module.exports = __webpack_public_path__ + "img/GAME_GUKHWAPPANG.fab8653b.png";